import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { formOptions } from "./constants";

const SanitationInfo = ({ formData, handleChange, errors }) => {
  return (
    <>
      <FormGroup>
        <Label for="buanganAirLimbahRumahTangga">42. Buangan Air Limbah Rumah Tangga</Label>
        <Input 
          type="select" 
          name="buanganAirLimbahRumahTangga" 
          id="buanganAirLimbahRumahTangga" 
          value={formData.buanganAirLimbahRumahTangga} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.buanganAirLimbahRumahTangga ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.buanganAirLimbahRumahTangga.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.buanganAirLimbahRumahTangga && <div className="invalid-feedback">{errors.buanganAirLimbahRumahTangga}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="saranaPengelolaanLimbahCair">43. Sarana Pengelolaan Limbah Cair Rumah Tangga</Label>
        <Input 
          type="select" 
          name="saranaPengelolaanLimbahCair" 
          id="saranaPengelolaanLimbahCair" 
          value={formData.saranaPengelolaanLimbahCair} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.saranaPengelolaanLimbahCair ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.saranaPengelolaanLimbahCair.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.saranaPengelolaanLimbahCair && <div className="invalid-feedback">{errors.saranaPengelolaanLimbahCair}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="pemiliharaanSaranaPengelolaanLimbah">44. Pemeliharaan Sarana Pengelolaan Limbah Cair Rumah Tangga</Label>
        <Input 
          type="select" 
          name="pemiliharaanSaranaPengelolaanLimbah" 
          id="pemiliharaanSaranaPengelolaanLimbah" 
          value={formData.pemiliharaanSaranaPengelolaanLimbah} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"} 
          className={errors.pemiliharaanSaranaPengelolaanLimbah ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.pemiliharaanSaranaPengelolaanLimbah.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.pemiliharaanSaranaPengelolaanLimbah && <div className="invalid-feedback">{errors.pemiliharaanSaranaPengelolaanLimbah}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="jenisTempatPembuanganAirTinja">45. Jenis Tempat Pembuangan Air Tinja</Label>
        <Input 
          type="select" 
          name="jenisTempatPembuanganAirTinja" 
          id="jenisTempatPembuanganAirTinja" 
          value={formData.jenisTempatPembuanganAirTinja} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.jenisTempatPembuanganAirTinja ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.jenisTempatPembuanganAirTinja.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.jenisTempatPembuanganAirTinja && <div className="invalid-feedback">{errors.jenisTempatPembuanganAirTinja}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="kepemilikanKamarMandiDanJamban">46. Kepemilikan Kamar Mandi Dan Jamban</Label>
        <Input 
          type="select" 
          name="kepemilikanKamarMandiDanJamban" 
          id="kepemilikanKamarMandiDanJamban" 
          value={formData.kepemilikanKamarMandiDanJamban} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.kepemilikanKamarMandiDanJamban ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kepemilikanKamarMandiDanJamban.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.kepemilikanKamarMandiDanJamban && <div className="invalid-feedback">{errors.kepemilikanKamarMandiDanJamban}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="jumlahJamban">47. Jumlah Jamban</Label>
        <Input 
          type="number" 
          name="jumlahJamban" 
          id="jumlahJamban" 
          value={formData.jumlahJamban} 
          onChange={handleChange} 
          className={errors.jumlahJamban ? "is-invalid" : ""}  
          disabled={formData.statusrumah === "Tidak Berpenghuni" || formData.kepemilikanKamarMandiDanJamban === "Tidak Ada"}
        />
        {errors.jumlahJamban && <div className="invalid-feedback">{errors.jumlahJamban}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="jenisKloset">48. Jenis Kloset</Label>
        <Input 
          type="select" 
          name="jenisKloset" 
          id="jenisKloset" 
          value={formData.jenisKloset} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni" || formData.kepemilikanKamarMandiDanJamban === "Tidak Ada"} 
          className={errors.jenisKloset ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.jenisKloset.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.jenisKloset && <div className="invalid-feedback">{errors.jenisKloset}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="jenisTangkiSeptik">49. Jenis Tangki Septik</Label>
        <Input 
          type="select" 
          name="jenisTangkiSeptik" 
          id="jenisTangkiSeptik" 
          value={formData.jenisTangkiSeptik} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni" || formData.kepemilikanKamarMandiDanJamban === "Tidak Ada"} 
          className={errors.jenisTangkiSeptik ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.jenisTangkiSeptik.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.jenisTangkiSeptik && <div className="invalid-feedback">{errors.jenisTangkiSeptik}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="materialTangkiSeptik">50. Material Tangki Septik</Label>
        <Input 
          type="select" 
          name="materialTangkiSeptik" 
          id="materialTangkiSeptik" 
          value={formData.materialTangkiSeptik} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni" || formData.kepemilikanKamarMandiDanJamban === "Tidak Ada"} 
          className={errors.materialTangkiSeptik ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.materialTangkiSeptik.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.materialTangkiSeptik && <div className="invalid-feedback">{errors.materialTangkiSeptik}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="alasTangkiSeptik">51. Alas Tangki Septik</Label>
        <Input 
          type="select" 
          name="alasTangkiSeptik" 
          id="alasTangkiSeptik" 
          value={formData.alasTangkiSeptik} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni" || formData.kepemilikanKamarMandiDanJamban === "Tidak Ada"} 
          className={errors.alasTangkiSeptik ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.alasTangkiSeptik.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.alasTangkiSeptik && <div className="invalid-feedback">{errors.alasTangkiSeptik}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="lubangPenyedotan">52. Lubang Penyedotan</Label>
        <Input 
          type="select" 
          name="lubangPenyedotan" 
          id="lubangPenyedotan" 
          value={formData.lubangPenyedotan} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni" || formData.kepemilikanKamarMandiDanJamban === "Tidak Ada"} 
          className={errors.lubangPenyedotan ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.lubangPenyedotan.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.lubangPenyedotan && <div className="invalid-feedback">{errors.lubangPenyedotan}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="posisiTangkiSeptik">53. Posisi Tangki Septik</Label>
        <Input 
          type="select" 
          name="posisiTangkiSeptik" 
          id="posisiTangkiSeptik" 
          value={formData.posisiTangkiSeptik} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni" || formData.kepemilikanKamarMandiDanJamban === "Tidak Ada"} 
          className={errors.posisiTangkiSeptik ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.posisiTangkiSeptik.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.posisiTangkiSeptik && <div className="invalid-feedback">{errors.posisiTangkiSeptik}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="jarakTangkiSeptikDenganSumberAir">54. Jarak Tangki Septik Dengan Sumber Air</Label>
        <Input 
          type="select" 
          name="jarakTangkiSeptikDenganSumberAir" 
          id="jarakTangkiSeptikDenganSumberAir" 
          value={formData.jarakTangkiSeptikDenganSumberAir} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni" || formData.kepemilikanKamarMandiDanJamban === "Tidak Ada"} 
          className={errors.jarakTangkiSeptikDenganSumberAir ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.jarakTangkiSeptikDenganSumberAir.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.jarakTangkiSeptikDenganSumberAir && <div className="invalid-feedback">{errors.jarakTangkiSeptikDenganSumberAir}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="sumberAirMinum">55. Sumber Air Minum</Label>
        <Input 
          type="select" 
          name="sumberAirMinum" 
          id="sumberAirMinum" 
          value={formData.sumberAirMinum} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"} 
          className={errors.sumberAirMinum ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.sumberAirMinum.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.sumberAirMinum && <div className="invalid-feedback">{errors.sumberAirMinum}</div>}
      </FormGroup>
    </>
  );
};

export default SanitationInfo;
